module.exports = __webpack_public_path__ + "img/logo.547581b7.png";